import { useMemo } from "react";
import {
  ArrowLeftRight,
  ArrowRightLeft,
  Briefcase,
  Calculator,
  DraftingCompass,
  Layers,
  PackageSearch,
  SlidersHorizontal,
  type LucideIcon,
} from "lucide-react";
import { matchEngagementLever, type EngagementLeverId } from "./engagementLevers";

const ICONS: Record<EngagementLeverId, LucideIcon> = {
  "design-changes": DraftingCompass,
  "specification-optimization": SlidersHorizontal,
  substitution: ArrowLeftRight,
  standardization: Layers,
  "should-cost": Calculator,
  "component-sourcing": PackageSearch,
  transition: ArrowRightLeft,
};

export function EngagementIcon({
  name,
  lever,
  size = 16,
}: {
  name: string;
  lever?: string | null;
  size?: number;
}): React.ReactElement {
  const match = useMemo(() => matchEngagementLever(name, lever), [name, lever]);
  const Icon = match ? ICONS[match.id] : Briefcase;
  const title = match
    ? match.diagnostic
      ? `${match.label} — diagnostic, not a savings lever`
      : `Suggested lever: ${match.label}`
    : "Others";

  return (
    <span title={title} aria-hidden="true" className="inline-flex shrink-0" data-engagement-lever={match?.id ?? "others"}>
      <Icon size={size} aria-hidden="true" focusable="false" />
    </span>
  );
}
